/**
 * 
 */
<template>
  <div>
    <el-button size="small" type="primary" icon="el-icon-search" @click="add"
      >新增</el-button
    >
    <el-table
      size="small"
      :data="list"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="ActivityBannerPicURL"
        label="轮播图片"
        width="350px"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 350px; height: 180px"
            :src="bannerUrl + scope.row.ActivityBannerPicURL"
            alt=""
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="序号" prop="IDX" width="55">
      </el-table-column>
      <el-table-column align="center" prop="InformationLinkURL" label="链接">
      </el-table-column>
      <el-table-column
        align="center"
        prop="CREATETIME"
        label="创建时间"
        min-width="120"
      >
      </el-table-column>
      <el-table-column label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="60%"
      @close="closeDialog('edit')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="链接" required prop="InformationLinkURL">
          <el-input v-model="ruleForm.InformationLinkURL"></el-input
        ></el-form-item>
        <el-form-item label="顺序" prop="IDX">
          <el-input type="textarea" v-model="ruleForm.IDX"></el-input>
        </el-form-item>
        <el-form-item label="轮播图片" prop="ActivityBannerPicURL">
          <mupload
            :fileList="fileList"
            FilePath="images/Banner"
            uploadName="upload"
            :canUpload="true"
            @handleUpload="handleUpload"
            @handleRemove="handleRemoveFile"
          ></mupload>
          <!-- <el-upload
            class="editor-upload"
            ref="upload"
            action=""
            :show-file-list="false"
            :limit="1"
            :auto-upload="false"
            :on-change="uploadImg"
          >
            <div class="flex flex_end">
              <img
                v-if="ruleForm.ActivityBannerPicURL"
                :src="ruleForm.ActivityBannerPicURL"
                class="avatar"
              />
              <div v-else class="flex-all avatar relative">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div slot="tip" class="el-upload__tip">
                说明：图片只允许上传一张
              </div>
            </div>
          </el-upload> -->
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import mupload from "@/components/upload.vue";
let flag = true;
export default {
  components: { mupload },
  data() {
    return {
      bannerUrl: this.$bannerUrl,
      loading: false,
      editFormVisible: false,
      formInline: {
        InformationLinkTitle: "",
      },
      list: [],
      fileList: [],
      ruleForm: {
        ActivityBannerPicURL: "",
        ActivityTypeName: "",
        InformationLinkURL: "",
        ActivityBannerGUID:'',
        IDX: "",
      },
      rules: {
        ActivityBannerPicURL: {
          required: true,
          message: "请上传图片",
          trigger: "blur",
        },
        ActivityTypeName: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        IDX: [{ required: true, message: "请输入", trigger: "change" }],
        InformationLinkURL: {
          required: true,
          message: "请输入链接",
          trigger: "blur",
        },
      },
    };
  },
  mounted() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.getData();
  },
  methods: {
    add() {
      this.editFormVisible = true;
    },
    search() {},

    handleDelete(index, row) {
      console.log(row, 273);
      this.$confirm("此操作将删除图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delTap(row.ActivityBannerGUID);
        })
        .catch(() => {});
    },
    delTap: function (BannerGUID) {
      let sqlCmdName = "ShopWebApp\\DeleteActivityBanner_1_0_1&DBC=w_m";
      let data = [
        {
          ActivityBannerGUID	:BannerGUID,
          CompanyGUID:this.personInfo.CompanyGUID
        },
      ];
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName, data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else {
          this.$message("删除成功");
          this.getData();
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("valid", valid);
          this.submitTap();
        }
      });
    },
    submitTap: function () {
      let {ruleForm} = this;
      console.log(ruleForm.ActivityBannerGUID,111,ruleForm)
      if (ruleForm.ActivityBannerGUID != "") {
        this.releaseNews(ruleForm.ActivityBannerGUID);
      } else {
        this.$api.returnGuid().then((guid)=> {
          this.releaseNews(guid);
        });
      }
    },
    releaseNews: function (ActivityBannerGUID) {
      let editForm = this.ruleForm;
      console.log(editForm,195,ActivityBannerGUID)
      let data = [
        {
          ActivityBannerGUID: ActivityBannerGUID,
          ActivityBannerPicURL: editForm.ActivityBannerPicURL,
          ActivityBannerLinkGUID:'',
          InformationLinkURL: editForm.InformationLinkURL,
          CompanyGUID: this.personInfo.CompanyGUID,
          IDX: editForm.IDX,
        },
      ];
      this.$loading();
      this.$api
        .ExSqlFn("Web\\UpdateActivityBanner_1_0_1&DBC=w_m", data)
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length == 0) {
            this.$message("提交失败");
          } else {
            this.getData();
            this.editFormVisible = false;
          }
        });
    },
    getData() {
      let data = {
          CompanyGUID: this.personInfo.CompanyGUID,
          InformationLinkTitle: "",
        },
        list = [];

      this.$loading();
      this.$api
        .QueryDataFn("ShopWebApp\\GetActivityBannerList_1_0_1&DBC=r_m", data)
        .then((res) => {
          let result = res.data;
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag.length <= 0) {
          } else {
            list = result.Tag[0].Table;
          }
          this.list = list;
        });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.ruleForm = row;
      this.getNewsDetail(row.ActivityBannerGUID);
      this.editFormVisible = true;
    },
    getNewsDetail(e) {
      let data = {
        ActivityBannerGUID: e,
      };
      this.$loading();
      this.$api
        .QueryDataFn("ShopWebApp\\GetActivityBannerInfo_1_0_1&DBC=r_m", data)
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message.error(result.Message);
          } else if (result.Tag.length <= 0) {
            this.$message.error(result.Message);
          } else {
            let editForm = result.Tag[0].Table[0];
            if (editForm.InformationPicURL) {
              let obj = {
                url: this.bannerUrl + editForm.InformationPicURL,
                name: editForm.InformationPicURL,
              };
              this.fileList = [obj];
            }
            this.ruleForm=editForm;
          }
        });
    },
    handleUpload(e) {
      console.log(e, 444);
      this.fileList = [e];
      this.ruleForm.ActivityBannerPicURL = e.name;
    },
    handleRemoveFile(e) {
      console.log(e, 30444);
      this.fileList = [];
      this.ruleForm.ActivityBannerPicURL = "";
    },
  },
};
</script>

<style scoped>
.avatar {
  border: 1px solid #666;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
.el-upload__tip {
  margin-left: 20px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/shop/upActiveLoop.vue